import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {AxiosResponse} from "axios";
import {ExecuteRFCManual, ExecutionLogRfc, IntegrationRoutines} from "../models/basic/integration-routines";
import {Client} from "../models/basic/client";

export class ImportAmortizationService extends AbstractService<IntegrationRoutines> {

    constructor() {
        super(URLS.IMPORT_INTEGRATION_ROUTINES);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        return processedFilter;
    }

    async executarRfcManual(payload: ExecuteRFCManual): Promise<AxiosResponse<any>> {
        return trackPromise(
            Api.post(`${this.path}executar/`, payload)
        );
    }

    async getClients(): Promise<AxiosResponse<Client[]>> {
        return trackPromise(
            Api.get(`${this.path}clientes/`)
        );
    }

    async getLogs(rfcId: number): Promise<AxiosResponse<ExecutionLogRfc>> {
        return trackPromise(
            Api.get(`${this.path}${rfcId}/log/`, {params: {expands: 'user'}})
        );
    }

    async getPlants(): Promise<AxiosResponse<any[]>> {
        return trackPromise(
            Api.get(`${this.path}plants/`)
        );
    }

}
